export default __webpack_public_path__ + "static/media/product-1.8e4f1fb9.jpg";